import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=173a95c5&scoped=true"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a95c5",
  null
  
)

export default component.exports